<mat-expansion-panel style="margin-bottom: 16px">
  <mat-expansion-panel-header> {{'shared.Filtra' | translate}} </mat-expansion-panel-header>
  <form [formGroup]="filtersForm" novalidate>
    <div class="u-flex-full">
      <mat-form-field floatLabel="always" class="u-full-width">
        <mat-label>{{'shared.Ricerca libera' | translate}}</mat-label>
        <input type="text" matInput formControlName="search" />
      </mat-form-field>
    </div>
    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>{{'risks.Area' | translate}}</mat-label>
        <app-risk-area-field formControlName="riskArea"> </app-risk-area-field>
      </mat-form-field>
      <mat-form-field class="u-full-width">
        <mat-label>{{'risks.Categoria contromisura' | translate}}</mat-label>
        <app-risk-category-field formControlName="riskCategory">
        </app-risk-category-field>
      </mat-form-field>
      <!-- <mat-form-field class="u-full-width">
        <mat-label>Risk owner</mat-label>
        <app-risk-owner-field formControlName="riskOwner">
        </app-risk-owner-field>
      </mat-form-field> -->
      <span class="u-flex-full">
        <button
          class="filter"
          mat-raised-button
          [disabled]="filtersForm.pristine"
          color="primary"
          (click)="applyFilters()"
        >
        {{'shared.Filtra' | translate}}
        </button>
        <button
          mat-icon-button
          *ngIf="!filtersForm.pristine"
          (click)="resetFilters()"
          matTooltip="{{'shared.Reset' | translate}}"
        >
          <mat-icon>replay</mat-icon>
        </button>
      </span>
    </div>
  </form>
</mat-expansion-panel>
